import FinanceBadge from "component/finance/FinanceBadge";
import { checkExpiry, truncateString } from "component/flex/utils";
import Loader from "component/loader";
import { Button } from "component/ui/Button";
import { financeDocumentTypes } from "constants/global";
import React from "react";
import { useNavigate } from "react-router-dom";

const LoanDocumentSection = ({ isLoadingBusinessDocsList, isCancelingFinanceLoading, docList,isBusinessApproved }) => {
    const navigate = useNavigate()
    return (
        <div className="w-full md:w-1/2 md:pt-9 seventh-step">
            <div className="w-full p-3 bg-white rounded-md">
                <p className="text-sm font-medium text-gray-90">Financing documents</p>

                {isLoadingBusinessDocsList || isCancelingFinanceLoading ? (
                    <div className="py-20 text-center">
                        <button className=" bg-[#6F00FF] px-4 py-2 rounded-lg">
                            <Loader />
                        </button>
                    </div>
                ) : docList?.length ? (
                    docList?.map((doc, index) => {
                        const isValid = checkExpiry(doc?.expiryDate);
                        return (
                            <div
                                key={index}
                                className="flex items-end justify-between gap-4 py-2 my-2"
                            >
                                <div>
                                    <p className="text-sm font-light text-gray-70">
                                        {financeDocumentTypes[doc?.name]}
                                    </p>
                                    <p className="font-[450] mb-1 text-gray-90 text-sm">
                                        {truncateString(doc?.filePath)}
                                    </p>

                                    <FinanceBadge
                                        badgeType={isValid !== "Expired" ? "Processing" : "Expired"}
                                        text={isValid}
                                    />
                                </div>
                                <div>
                                    <Button
                                        disabled={isValid !== "Expired"}
                                        size="sm"
                                        variant="outline"
                                        className="text-sm text-gray-90"
                                        onClick={() => navigate("/finance/credit/request")}
                                    >
                                        Upload
                                    </Button>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    ["Board resolution to request finance", "Bank statement"]?.map((doc, index) => {
                        return (
                            <div
                                key={index}
                                className="flex items-end justify-between gap-4 py-2 my-2"
                            >
                                <div>
                                    <p className="text-sm font-light text-gray-70">{doc}</p>
                                    <p className="font-[450] mb-1 text-gray-90 text-sm">
                                        No file uploaded
                                    </p>

                                    <FinanceBadge badgeType={"pending"} text={"Pending"} />
                                </div>
                                <div>
                                    <Button
                                        size="sm"
                                        variant="outline"
                                        className="text-sm text-gray-90"
                                        onClick={() => navigate("/finance/credit/request")}
                                        disabled={!isBusinessApproved}
                                    >
                                        Upload
                                    </Button>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default LoanDocumentSection;
